<template>
    <div>
        <!-- <div class="keyword-search">
            {{ `'${keyword}'` }}
        </div> -->
        <div class="sub-header">
            <div class="search-by">
                <div class="text">
                    {{ lbl.searchList.searchBy }} :
                </div>
                <div class="tag-search">
                    {{dataFilter.campaignFilter.name}}
                    <img class="close-tag" @click="clearSearch('category')" src="@/assets/icon/ic-close.svg"/>
                </div>
                <div v-if="filterSearch.rangePrice" class="tag-search">
                    ราคา {{dataFilter.min}} - {{dataFilter.max}}
                    <img class="close-tag" @click="clearSearch('rangePrice')" src="@/assets/icon/ic-close.svg"/>
                </div>
                <div v-if="filterSearch.agency" class="tag-search">
                    {{dataFilter.agencyFilter.name}}
                    <img class="close-tag" @click="clearSearch('agency')" src="@/assets/icon/ic-close.svg"/>
                </div>
                <div class="clear-search" @click="clearSearch('all')">
                    {{ lbl.searchList.clearSearch }}
                </div>
            </div>
            <div class="order-by">
                {{ lbl.searchList.orderBy }} :
                <ButtonDropdown
                    ref="buttonDropdown"
                    @orderBy="setOrderBy($event)"
                ></ButtonDropdown>
            </div>
        </div>
        <template v-if="isFound">
            <div class="grid-template">
                <div v-for="(campaign, idx) in campaigns" :key="idx" class="item-grid" @click="clickCampaign(campaign.id)">
                    <img class="item-img" :src="campaign.fullImageUrl"/>
                    <div class="item-name">
                        {{campaign.name}}
                    </div>
                    <div class="item-detail">
                        <div>
                            <div class="item-price-per-unit">
                                ฿ {{campaign.pricePerUnit}}
                            </div>
                            <div class="item-original-price">
                                ฿ {{campaign.originalPrice}}
                            </div>
                        </div>
                        <div class="btn-cart">
                            <img class="img-cart" src="@/assets/icon/ic-btn-cart.svg"/>
                        </div>
                    </div>
                    <div class="discount" v-if="campaign.discount > 0">
                        <div class="discount-img">
                            <img src="@/assets/new/bg/bg-discount.png"/>
                            <div class="discount-text">
                                <div class="text">ลด</div>
                                <div class="text">{{ getDiscount(campaign) }}%</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="not-found">
                <img class="img" src="@/assets/bg/bg-not-found.svg" />
                <!-- <div class="text">
                    ไม่พบสินค้าที่ตรงกับ {{ `'${keyword}'` }}
                    <br>ลองเปลี่ยนคำ หรือใช้คำที่มีความหมายกว้างกว่านี้
                </div> -->
                <div class="text">{{ lbl.searchList.nodata }}</div>
            </div>
            <div class="may-like">
                {{ lbl.searchList.mayLike }}
            </div>
            <div class="grid-template">
                <div v-for="(campaign, idx) in campaigns" :key="idx" class="item-grid">
                    <img class="item-img" :src="campaign.fullImageUrl"/>
                    <div class="item-name">
                        {{campaign.name}}
                    </div>
                    <div class="item-detail">
                        <div>
                            <div class="item-price-per-unit">
                                ฿ {{campaign.pricePerUnit}}
                            </div>
                            <div class="item-original-price">
                                ฿ {{campaign.originalPrice}}
                            </div>
                        </div>
                        <div class="btn-cart">
                            <img class="img-cart" src="@/assets/icon/ic-btn-cart.svg"/>
                        </div>
                    </div>
                    <div class="discount" v-if="campaign.discount > 0">
                        <div class="discount-img">
                            <img src="@/assets/new/bg/bg-discount.png"/>
                            <div class="discount-text">
                                <div class="text">ลด</div>
                                <div class="text">{{ getDiscount(campaign) }}%</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
// components
import ButtonDropdown from '../ButtonDropdown/ButtonDropdown.vue';
// helper
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/Locale.js";
// service
import BzbsCampaign from "@/service/BzbsCampaign.js";

import Util from "@/helper/Utility";

export default {
    components: {
        ButtonDropdown,
    },
    props: {
        blobConfig: Object,
        // lbl: Object,
        isLoading: Boolean,
        initListConfig: Object,
        initFilterConfig: Object,
        initIsFlashSale: Boolean,
        query: Object,
        busEvent: Object,
        modalController: Object,
        dataFilter: Object
    },
    data() {
        return {
            lbl: Locale.getLbl(),
            campaigns: [],
            listConfig: {},
            filterConfig: {},
            isHaveItem: false,
            isLoaded: false,
            filterSearch: {
                rangePrice: false,
                agency: false
            },
            orderBy: 'price_asc',
            isFound: true,
            isGetList: false
        }
    },
    created () {
        this.listConfig = this.initListConfig;
        this.filterConfig = this.initFilterConfig;
        this.getList();
    },
    mounted () {
        this.busEvent.$on("reInitList", this.reInitialList);
    },
    computed: {
        keyword() {
            return this.$route.params.keyword ? this.$route.params.keyword : ``
        }
    },
    methods: {
        getList: function(fetchMore = false) {
            // console.log(`🚀 ~ file: CampaignList.vue:178 ~ fetchMore:`, fetchMore)
            if (!this.listConfig.strConfigList) return;

            this.listConfig['intSkip'] = 0
            this.listConfig['sortby'] = this.orderBy
            this.listConfig['q'] = this.keyword

            // console.log(`🚀 ~ file: CampaignList.vue:160 ~ this.listConfig:`, this.listConfig)
            // console.log(`🚀 ~ file: CampaignList.vue:161 ~ this.filterConfig:`, this.filterConfig)

            if (fetchMore) {
                // campaign_b2b_marketplace_relate
                this.listConfig['intSkip'] = 0;
                this.listConfig['strConfigList'] = 'campaign_b2b_marketplace_relate'
                this.listConfig['strCatId'] = ''
                this.filterConfig['intMinPrice'] = 0
                this.filterConfig['intMaxPrice'] = 999999
                this.filterConfig['strLocationAgencyId'] = ''
                this.isFound = false
            }else{
                this.isFound = this.listConfig['strConfigList'] === 'campaign_b2b_marketplace'
            }
            if(this.listConfig['strConfigList'] === 'campaign_b2b_marketplace_relate'){
                delete this.listConfig['q']
                delete this.filterConfig['strLocationAgencyId']
                // delete
            }

            if (this.isGetList) return;

            this.isGetList = true;

            var strBzbsToken = Account.getToken();

            BzbsCampaign.apiGetCampaign(strBzbsToken, this.listConfig, this.filterConfig)
                .then(campaigns => {
                    // console.log(`🚀 ~ file: CampaignList.vue:194 ~ campaigns:`, campaigns)

                    //check search and return data 0 length.
                    if(campaigns.length === 0 && this.listConfig['strConfigList'] !== 'campaign_b2b_marketplace_relate') {
                        this.getList(true)
                        return
                    }

                    this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                    //check is there are more campaign.
                    if (campaigns &&
                        campaigns.length < this.listConfig.defaultTopAmount) {
                            this.listConfig.isSeeMoreEnable = false;
                        } else {
                            this.listConfig.isSeeMoreEnable = true;
                        }

                    //reinitialize list if no skip.
                    if (this.listConfig.intSkip ==
                        this.listConfig.defaultTopAmount)
                        this.campaigns = [];

                    for (var campaign of campaigns) {
                        //TODO: Add GA Tracking.
                        this.campaigns.push(campaign);
                    }

                    this.isGetList = false
                    this.isLoaded = true;
                    this.isHaveItem = this.campaigns.length > 0
                        ? true
                        : false;

                    this.$emit('onLoaded');
                    // console.log('this.campaigns',this.campaigns)

                    // this.hideLoading();
                }).catch(error => {
                    this.isGetList = false
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    // this.hideLoading();
                    console.log(error);
                });
        },
        resetLoaded: function () {
            this.campaigns = [];
            this.isLoaded = false;
            this.isHaveItem = false;
        },
        reInitialList: function (data) {
            if (!this.isLoaded) return;
            this.resetLoaded();
            this.listConfig = data.listConfig;
            this.filterConfig = data.filterConfig;
            this.isFlashSale = data.isFlashSale;

            if (!this.listConfig.strConfigList) {
                this.isLoaded = true;
                return;
            }

            this.showLoading();
            this.getList();
        },
        showLoading: function () {
            if (this.isLoading) return true;

            this.modalController.loadingModal.show();

            return false;
        },
        loadMore: function() {
            if (!this.listConfig.isSeeMoreEnable) return;
            if (!this.listConfig.strConfigList) return;
            if (this.showLoading()) return;

            this.listConfig.isSeeMoreEnable = false;
            setTimeout(() => {
                this.getList();
            }, 500);
        },
        // hideLoading: function () {
        //     this.modalController.loadingModal.hide();
        // },
        setOrderBy: function(by) {
            this.orderBy = by
            this.getList()
        },
        clearSearch: function(clear) {
            switch(clear) {
                case 'all':
                    this.listConfig['strConfigList'] ='campaign_b2b_marketplace'
                    this.filterSearch = {
                        rangePrice: false,
                        agency: false
                    };
                    this.setOrderBy('price_asc')
                    this.$refs.buttonDropdown.setValue(this.orderBy)
                    break;
                case 'rangePrice':
                    this.filterSearch['rangePrice'] = false;
                    break;
                case 'agency':
                    this.filterSearch['agency'] = false;
                    break;
            }
            this.$emit('clearSearch', clear)
        },
        clickCampaign: function (id) {
            //GA
            var path = '/campaign/' + id;
            this.$router.push(path);
        },
        getDiscount: function(campaign) {
            return Util.formatNum(campaign.discount)
        }
    },
    watch: {
        dataFilter(newValue) {
            if(newValue.min !== 0 || newValue.max !== 999999){
                this.filterSearch.rangePrice = true
            }
            if(newValue.agencyFilter.id) {
                this.filterSearch.agency = true
            }
            // console.log(`🚀 ~ file: CampaignList.vue:217 ~ dataFilter ~ oldValue.agencyFilter:`, oldValue.agencyFilter)
            // console.log(`🚀 ~ file: CampaignList.vue:217 ~ dataFilter ~ newValue.agencyFilter:`, newValue.agencyFilter)
            // console.log(`🚀 ~ file: CampaignList.vue:219 ~ dataFilter ~ this.filterSearch:`, this.filterSearch)

        }
    },
}
</script>

<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import './CampaignList.scss';
</style>
